export default __webpack_public_path__ + "static/media/ama_logo.619191f6.png";